import React from "react";

const Input = ({ id, label, register, validationSchema, ...inputProps }) => {
	return (
		<div className="mt-2">
			<label
				htmlFor={id}
				className="block mb-2 text-sm font-medium text-gray-900">
				{label}
			</label>
			<input
				className={`bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5`}
				id={id}
				name={id}
				{...inputProps}
				{...register(id, validationSchema)}
			/>
		</div>
	);
};

export default Input;
